<blockable-div #block>
  <app-progress-spinner [enabled]="!contactList || view()?.loading()!" />
  <p-blockUI
    [blocked]="saving === true || loading === true || view()?.loading()"
    [target]="block"
  />
  @if (contactList()) {
    <div id="facility-create-form">
      <div id="facility-form-content">
        <div class="no-padding-top-bottom-top-bottom">
          <div class="button-wrapper button-header">
            @if (saving) {
              <div>
                <app-progress-spinner [enabled]="saving" />
              </div>
            }
            <div class="button-wrapper button-grouping align-left">
              <p-select
                #dd
                [options]="actions"
                [(ngModel)]="selectedAction"
                (onChange)="actionEvent($event, dd)"
                [ngModelOptions]="{ standalone: true }"
                styleClass="action-drop-down"
              />
            </div>
          </div>
        </div>
        <hr id="facility-scroll-divider" />
        <div>
          <div>
            <div id="facility-tab-view">
              <p-tabs [value]="tabIndex">
                <p-tablist>
                  <p-tab [value]="0">{{
                    'CONTACT.SCREEN.CONTACT_LIST' | translate
                  }}</p-tab>
                  <p-tab [value]="1">{{
                    'LOCATION.LABEL.FACILITIES' | translate
                  }}</p-tab>
                  @if (canViewUpdaters) {
                    <p-tab [value]="2">{{
                      'CONTACT.SCREEN.UPDATERS' | translate
                    }}</p-tab>
                  }
                  <p-tab
                    [value]="canViewUpdaters ? 3 : 2"
                    (click)="clickedSchedule()"
                    >{{ 'CONTACT.SCREEN.SCHEDULE' | translate }}</p-tab
                  >
                  @if (canSchedule) {
                    <p-tab [value]="canViewUpdaters ? 4 : 3">{{
                      'CONTACT.SCREEN.SCHEDULE_IMPORT_EXPORT' | translate
                    }}</p-tab>
                  }
                </p-tablist>
                <p-tabpanels>
                  <p-tabpanel [value]="0">
                    <app-contact-list-simple-view-container
                      [contactSchedules]="events"
                      [contactList]="contactList()"
                      [embedded]="false"
                      #sview
                    />
                  </p-tabpanel>
                  <p-tabpanel [value]="1">
                    <div class="facilities-tab">
                      @if (canCreate === true) {
                        <div class="dropdowns">
                          <p-panel
                            [showHeader]="false"
                            styleClass="facility-contact-list-add-panel"
                          >
                            <div>
                              <form
                                [formGroup]="addToFacilityForm"
                                class="facilities-dropdowns"
                              >
                                <div
                                  class="no-padding-top-bottom-top-bottom facilities-form-row"
                                >
                                  <span class="label text-right"
                                    >{{
                                      'LOCATION.LABEL.STATE' | translate
                                    }}:</span
                                  >
                                  <span>
                                    <p-autoComplete
                                      [suggestions]="filteredStates"
                                      (completeMethod)="stateSearch($event)"
                                      formControlName="state"
                                      [dropdown]="true"
                                      appendTo="body"
                                      [virtualScroll]="true"
                                      [virtualScrollItemSize]="34"
                                    />
                                  </span>
                                </div>
                                <div
                                  class="no-padding-top-bottom-top-bottom facilities-form-row"
                                >
                                  <span class="label text-right"
                                    >{{
                                      'LOCATION.LABEL.COUNTY' | translate
                                    }}:</span
                                  >
                                  <span>
                                    <p-autoComplete
                                      [suggestions]="filteredCounties"
                                      (completeMethod)="
                                        countySearch($event, addToFacilityForm)
                                      "
                                      formControlName="county"
                                      [dropdown]="true"
                                      optionLabel="county"
                                      (onSelect)="
                                        selectCounty($event, addToFacilityForm)
                                      "
                                      appendTo="body"
                                      [virtualScroll]="true"
                                      [virtualScrollItemSize]="34"
                                    />
                                  </span>
                                </div>
                                <div
                                  class="no-padding-top-bottom-top-bottom facilities-form-row"
                                >
                                  <span class="label text-right"
                                    >{{
                                      'LOCATION.LABEL.TOWNSHIP' | translate
                                    }}:</span
                                  >
                                  <span>
                                    <p-autoComplete
                                      [suggestions]="filteredTownships"
                                      (completeMethod)="
                                        townshipSearch(
                                          $event,
                                          addToFacilityForm
                                        )
                                      "
                                      formControlName="township"
                                      [dropdown]="true"
                                      optionLabel="township"
                                      (onSelect)="
                                        selectTownship(
                                          $event,
                                          addToFacilityForm
                                        )
                                      "
                                      appendTo="body"
                                      [virtualScroll]="true"
                                      [virtualScrollItemSize]="34"
                                    />
                                  </span>
                                </div>
                                <div
                                  class="no-padding-top-bottom-top-bottom facilities-form-row"
                                >
                                  <span class="label text-right"
                                    >{{
                                      'LOCATION.LABEL.FACILITY_NAME'
                                        | translate
                                    }}:</span
                                  >
                                  <span>
                                    <p-autoComplete
                                      [suggestions]="filteredFacilities"
                                      (completeMethod)="
                                        facilitySearch($event, 'facilityName')
                                      "
                                      formControlName="facility"
                                      [dropdown]="true"
                                      optionLabel="facilityName"
                                      (onSelect)="selectFacility($event)"
                                      appendTo="body"
                                      [virtualScroll]="true"
                                      [virtualScrollItemSize]="34"
                                    />
                                  </span>
                                </div>
                                <div
                                  class="no-padding-top-bottom-top-bottom facilities-form-row"
                                >
                                  <span class="label text-right"
                                    >{{
                                      'LOCATION.LABEL.FACILITY_UID' | translate
                                    }}:</span
                                  >
                                  <span>
                                    <p-autoComplete
                                      [suggestions]="filteredFacilities"
                                      (completeMethod)="
                                        facilitySearch($event, 'facilityUid')
                                      "
                                      formControlName="facility"
                                      [dropdown]="true"
                                      optionLabel="facilityUid"
                                      (onSelect)="selectFacility($event)"
                                      appendTo="body"
                                      [virtualScroll]="true"
                                      [virtualScrollItemSize]="34"
                                    />
                                  </span>
                                </div>
                                <div class="facilities-form-row">
                                  <label for="contactList"
                                    >{{
                                      'CONTACT.SCREEN.CONTACT_LIST' | translate
                                    }}:</label
                                  >
                                  <p-radiobutton
                                    formControlName="facilityContactListType"
                                    value="contactList"
                                    class="contact-list-type-radio"
                                  />
                                  <label for="managementContactList"
                                    >{{
                                      'LOCATION.LABEL.MANAGEMENT_CONTACT_LIST'
                                        | translate
                                    }}:</label
                                  >
                                  <p-radiobutton
                                    formControlName="facilityContactListType"
                                    value="managementContactList"
                                    class="contact-list-type-radio"
                                  />
                                  @if (
                                    contactList()?.AdditionalResourceListType
                                      ?.id
                                  ) {
                                    <label for="additionalResourceList"
                                      >{{
                                        'CONTACT.LABEL.ADDITIONAL_RESOURCE_LIST'
                                          | translate
                                      }}:</label
                                    >
                                    <p-radiobutton
                                      formControlName="facilityContactListType"
                                      value="additionalResourceList"
                                      class="contact-list-type-radio"
                                    />
                                  }
                                </div>
                                <div
                                  class="no-padding-top-bottom-top-bottom button-row"
                                >
                                  <div class="button">
                                    <button
                                      pButton
                                      label="{{
                                        'COMMON.LABEL.BUTTONS.ADD' | translate
                                      }}"
                                      icon="fa fa-fw fa-save"
                                      (click)="addContactListToFacility()"
                                      [disabled]="!this.addToFacilityForm.valid"
                                    ></button>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </p-panel>
                        </div>
                      }
                      <section id="facilities-lists">
                        <div class="facilities-table-header">
                          <div class="facilities-table-header-content">
                            <div class="filter-container input">
                              <div id="facility-name-wrapper">
                                <input
                                  type="search"
                                  pInputText
                                  placeholder="{{
                                    'LOCATION.LABEL.SEARCH_BY_FACILITY_NAME'
                                      | translate
                                  }}"
                                  (keyup)="filterFacilities($event)"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <app-contact-list-facilities
                          [facilities]="contactListFacilities()"
                          [canDelete]="canDelete"
                          [header]="clFacilitiesHeader()"
                          (deleteContactListEvent)="
                            deleteContactListFromFacility($event, 'contactList')
                          "
                          (openFacilityEvent)="openFacility($event)"
                        />
                        <app-contact-list-facilities
                          [facilities]="managementFacilities()"
                          [canDelete]="canDelete"
                          [header]="managementFacilitiesHeader()"
                          (deleteContactListEvent)="
                            deleteContactListFromFacility(
                              $event,
                              'managementContactList'
                            )
                          "
                          (openFacilityEvent)="openFacility($event)"
                        />
                        @if (contactList()?.AdditionalResourceListType?.id) {
                          <app-contact-list-facilities
                            [facilities]="additionalResourceListFacilities()"
                            [canDelete]="canDelete"
                            [header]="additionalResourceListFacilitiesHeader()"
                            (deleteContactListEvent)="
                              deleteContactListFromFacility(
                                $event,
                                'additionalResourceList'
                              )
                            "
                            (openFacilityEvent)="openFacility($event)"
                          />
                        }
                      </section>
                    </div>
                  </p-tabpanel>
                  @if (canViewUpdaters) {
                    <p-tabpanel [value]="2">
                      @if (canCreate) {
                        <div id="add-updater-container">
                          <div>
                            <span class="label"
                              >{{ 'CONTACT.LABEL.CONTACTS' | translate }}:</span
                            >
                            <span>
                              <p-autoComplete
                                [suggestions]="filteredContacts"
                                (completeMethod)="contactSearch($event)"
                                [(ngModel)]="selectedUpdater"
                                [dropdown]="true"
                                optionLabel="label"
                                optionValue="value"
                                appendTo="body"
                                [virtualScroll]="true"
                                [virtualScrollItemSize]="34"
                              />
                            </span>
                          </div>
                          <div class="button-wrapper">
                            <div>
                              <button
                                pButton
                                label="{{
                                  'COMMON.LABEL.BUTTONS.ADD' | translate
                                }}"
                                icon="fa fa-fw fa-save"
                                (click)="addContactAsUpdater()"
                              ></button>
                            </div>
                          </div>
                        </div>
                      }
                      <div class="break"></div>
                      @for (u of contactList()!.updaters; track u) {
                        <div class="updater-container">
                          @if (u.dirtyStatus !== DirtyStatus.DELETED) {
                            <p-panel [showHeader]="false">
                              <div>
                                <div>
                                  <i
                                    class="fa fa-fw fa-minus-circle updater-delete-icon"
                                    (click)="removeContactAsUpdater(u.id)"
                                  ></i
                                  >{{ u?.label }}
                                </div>
                              </div>
                            </p-panel>
                          }
                        </div>
                      }
                    </p-tabpanel>
                  }
                  <p-tabpanel [value]="canViewUpdaters ? 3 : 2">
                    <div class="schedule">
                      <full-calendar [options]="calendarOptions" />
                      @if (canSchedule) {
                        <app-schedule-form
                          [isVisible]="scheduleFormVisible"
                          (scheduleFormHidden)="onScheduleFormHidden()"
                          (scheduleFormSubmitted)="
                            onScheduleFormSubmitted($event)
                          "
                          [minDateTime]="today"
                          (scheduleDeleted)="onScheduleDeleted($event)"
                          [scheduleToEdit]="selectedSchedule"
                          [formType]="scheduleFormType"
                          [isLoading]="loading"
                          [contactList]="contactList()!"
                          [contacts]="memberContactArray"
                          #scheduleForm
                        />
                      }
                    </div>
                    <br /><br />
                  </p-tabpanel>
                  @if (canSchedule) {
                    <p-tabpanel [value]="canViewUpdaters ? 4 : 3">
                      <app-schedule-import
                        [contactList]="contactList()!"
                        (scheduleImported)="onScheduleImported()"
                        (scheduleExported)="onScheduleExport()"
                      />
                    </p-tabpanel>
                  }
                </p-tabpanels>
              </p-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (contactList() && this._deviceService.isMobile()) {
    <div>
      <app-contact-list-simple-view-container [contactList]="contactList()" />
    </div>
  }
</blockable-div>
